import React from 'react';
import EntityListFetcher from '../components/EntityListFetcher';
import typeIntro from '../static/introspection/Good360.json';
import { ENTITY } from '../utils/entities';
import { Good360ListQuery } from 'graphql/query/Good360ListQuery';
import Good360Filters from '../static/introspection/Good360FilterInput.json';

const Good360List = () => (
	<EntityListFetcher
		query={Good360ListQuery}
		entityName={ENTITY.GOOD_360}
		headers={['Good', 'status']}
		typeIntro={typeIntro}
		filtersIntro={Good360Filters}
		filterFields={['Good', 'statuses']}
	/>
);

export { Good360List };